(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model-symbol', {
            parent: 'entity',
            url: '/model-symbol?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelSymbol.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-symbol/model-symbols.html',
                    controller: 'ModelSymbolController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelSymbol');
                    $translatePartialLoader.addPart('modelSymbolType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-symbol-detail', {
            parent: 'entity',
            url: '/model-symbol/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelSymbol.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-symbol/model-symbol-detail.html',
                    controller: 'ModelSymbolDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelSymbol');
                    $translatePartialLoader.addPart('modelSymbolType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ModelSymbol', function($stateParams, ModelSymbol) {
                    return ModelSymbol.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('model-symbol.new', {
            parent: 'model-symbol',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-symbol/model-symbol-dialog.html',
                    controller: 'ModelSymbolDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                unit: null,
                                label: null,
                                latexAlias: null,
                                isAdditive: null,
                                isMeasurement: null,
                                value: null,
                                valueTrend: null,
                                symbolType: null,
                                labelShort: null,
                                shock_peer_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model-symbol', null, { reload: true });
                }, function() {
                    $state.go('model-symbol');
                });
            }]
        })
        .state('model-symbol.edit', {
            parent: 'model-symbol',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-symbol/model-symbol-dialog.html',
                    controller: 'ModelSymbolDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ModelSymbol', function(ModelSymbol) {
                            return ModelSymbol.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-symbol', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model-symbol.delete', {
            parent: 'model-symbol',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-symbol/model-symbol-delete-dialog.html',
                    controller: 'ModelSymbolDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModelSymbol', function(ModelSymbol) {
                            return ModelSymbol.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-symbol', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
